import * as React from "react";
import AuthenticationLayoutInternal from "./AuthenticationLayoutInternal";
import GlobalState from "globalState";
import { connect } from "react-redux";

const AuthenticationLayout = connect(
    (state: GlobalState) => {
        return {
            unhandledError: state.unhandledError
        };
    }
)(AuthenticationLayoutInternal);

export default AuthenticationLayout;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/authentication/AuthenticationLayout/AuthenticationLayout.tsx